import { render, staticRenderFns } from "./Sidebar_Button_Language.vue?vue&type=template&id=d79210d0&scoped=true&"
import script from "./Sidebar_Button_Language.vue?vue&type=script&lang=js&"
export * from "./Sidebar_Button_Language.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar_Button_Language.vue?vue&type=style&index=0&id=d79210d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79210d0",
  null
  
)

export default component.exports